class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');
    this.hoverOpenDelay = 120;
    this.hoverCloseDelay = 160;
    this.hoverOpenTimeout = null;
    this.hoverCloseTimeout = null;

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);

    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter);
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave);
    this.summary.addEventListener('click', this.onSummaryClick);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.desktopMediaQuery.matches) {
      const anyMegaOpen = Boolean(document.querySelector('details.mega-menu[open]'));
      this.header.classList.toggle('mega-menu-backdrop-active', anyMegaOpen);
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }
  }

  onMouseEnter() {
    if (!this.desktopMediaQuery.matches || !this.mainDetailsToggle.classList.contains('mega-menu')) return;
    if (this.hoverCloseTimeout) clearTimeout(this.hoverCloseTimeout);

    this.hoverOpenTimeout = setTimeout(() => {
      this.mainDetailsToggle.setAttribute('open', true);
      this.summary.setAttribute('aria-expanded', true);
    }, this.hoverOpenDelay);
  }

  onMouseLeave() {
    if (!this.desktopMediaQuery.matches || !this.mainDetailsToggle.classList.contains('mega-menu')) return;
    if (this.hoverOpenTimeout) clearTimeout(this.hoverOpenTimeout);

    this.hoverCloseTimeout = setTimeout(() => {
      this.close();
    }, this.hoverCloseDelay);
  }

  onSummaryClick(event) {
    if (!this.desktopMediaQuery.matches || !this.mainDetailsToggle.classList.contains('mega-menu')) return;

    const linkUrl = this.summary.dataset.linkUrl;
    if (!linkUrl) return;

    event.preventDefault();
    window.location.href = linkUrl;
  }
}

customElements.define('header-menu', HeaderMenu);
